import { render, staticRenderFns } from "./BlmRichtext.vue?vue&type=template&id=333d2b0f&scoped=true"
import script from "./BlmRichtext.vue?vue&type=script&lang=js"
export * from "./BlmRichtext.vue?vue&type=script&lang=js"
import style0 from "./BlmRichtext.vue?vue&type=style&index=0&id=333d2b0f&prod&scoped=true&lang=less"
import style1 from "./BlmRichtext.vue?vue&type=style&index=1&id=333d2b0f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d2b0f",
  null
  
)

export default component.exports